import React from "react";
import styles from "./noRecording.module.scss";

type ImageSrc= { voiceMailEmptySrc?:any }
export default function NoRecording({voiceMailEmptySrc}:ImageSrc) {
  return (
    <>
      <div className={styles.noMessage}>
        <div className={styles.noMessageinner}>
          <img src={voiceMailEmptySrc} alt="" />
          <p className={styles.noMessageTitle}>No Recordings Found</p>
          <p className={styles.noMessageDesc}>
          </p>
          <div className={styles.recentBtn}>
            <span className="icon_outlineleftarrow"></span>
            <span>no  detail</span>
          </div>
        </div>
      </div>
    </>
  );
};

